import { ensure, getLocalDate } from 'buzz_lib_shared';
export const isPastDate = date => _normalizeDate(new Date(date)) < _normalizeDate(new Date());
const _normalizeDate = date => {
  const localDate = getLocalDate(date);
  ensure(localDate);
  localDate.setHours(0, 0, 0, 0);
  return localDate;
};